import { useTranslation } from 'react-i18next';
import { type LocationPickerProps } from '../types';

/** The picker's label and placeholder, which callers can override. */
export const usePickerLabels = ({
  label,
  placeholder,
  multiSelect,
}: Pick<LocationPickerProps, 'label' | 'placeholder' | 'multiSelect'>) => {
  const { t } = useTranslation();

  return {
    label: label ?? (multiSelect ? t('filter.businessPartners') : t('filter.businessPartner')),
    placeholder:
      placeholder ??
      (multiSelect
        ? t('filter.businessPartnersPlaceholder')
        : t('filter.businessPartnerPlaceholder')),
  };
};
